// FAQ.tsx
import React, { useState } from 'react';
import faqsjson from './Faqs.json';
import devfaqs from './devFaqs.json';
import HeaderComponent from '../../components/HeaderComponent';

interface FAQs {
  question: string;
  answer: string;
}

const FAQs: React.FC = () => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const [openIndexDev, setOpenIndexDev] = useState<number | null>(null);

  const toggleFAQDev = (index: number) => {
    setOpenIndexDev(openIndexDev === index ? null : index);
  };

  const renderAnswer = (answer: string) => {
    return answer.split('\n').map((line, index) => (
      <React.Fragment key={index}>
        &nbsp;&nbsp;{line}
        <br />
      </React.Fragment>
    ));
  };


  return (
    <div>
        <HeaderComponent />
        <h3> General FAQs</h3>
      {faqsjson.map((faq: FAQs, index: number) => (
        <div key={index}>
          <div className='section' onClick={() => toggleFAQ(index)} style={{ cursor: 'pointer' }}>
            {faq.question} {openIndex === index ? '-' : '+'}
          </div>
          {openIndex === index && <div>{renderAnswer(faq.answer)}</div>}
        </div>
      ))}
        <h3> Developer FAQs</h3>
      {devfaqs.map((faq: FAQs, index: number) => (
        <div key={index}>
          <div className='section' onClick={() => toggleFAQDev(index)} style={{ cursor: 'pointer' }}>
            {faq.question} {openIndexDev === index ? '-' : '+'}
          </div>
          {openIndexDev === index && <div>{renderAnswer(faq.answer)}</div>}
        </div>
      ))}
    </div>
  );
};

export default FAQs;
